import angular from 'angular';
import sendTaxInvoiceModal from './sendTaxInvoiceModal';

export default angular
  .module('components.sendTaxInvoiceModal', [])
  .component('sendTaxInvoiceModal', sendTaxInvoiceModal).name;
